import { currencyInput } from '@/_schemas/generic';

import type { InvoiceFormSchema } from '../schemas';

export const defaultValues: Readonly<InvoiceFormSchema> = {
  id: -1,
  invoice_number: '',

  invoice_date: '',
  invoice_batch_id: null,

  client: { name: 'All Companies', id: -1, account_number: -1, logo: [] },
  brand: null,
  partner: null,
  notes: '',
  status: null,
  execution_status: null,
  agreement_links: [],

  due_date: null,
  invoice_amount: currencyInput.defaultValue(),
};
